// Display helpers shared by the Trending grid (ShoppingList.tsx) and the
// Trending detail screen (LatticeSeedDetailModal.tsx).

// Lattice store names carry the street address ("Vons, 8949 N Cedar Ave").
export function splitStoreName(storeName: string | null | undefined): { name: string; address: string | null } {
  if (!storeName) return { name: '', address: null };
  const idx = storeName.indexOf(',');
  if (idx <= 0) return { name: storeName.trim(), address: null };
  return { name: storeName.slice(0, idx).trim(), address: storeName.slice(idx + 1).trim() || null };
}

export function formatSeedDistance(miles: number | null | undefined, unit: string): string | null {
  if (miles == null || !Number.isFinite(miles)) return null;
  if (miles < 0.1) return `< 0.1 ${unit}`;
  return `${miles < 10 ? miles.toFixed(1) : Math.round(miles)} ${unit}`;
}

export function formatSeedDate(date: string, locale: string, todayLabel: string): string {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  if (d.toDateString() === now.toDateString()) return todayLabel;
  return d.toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
    ...(d.getFullYear() !== now.getFullYear() ? { year: 'numeric' } : {}),
  });
}
